import React from 'react';
import { ReactComponent as ThunderIcon } from 'src/assets/icons/thunder-icon.svg';
import cx from 'classnames';

type SproutsAIBadgeV2Props = {
  type: 'primary' | 'secondary' | 'transparent';
  size: 'small' | 'medium' | 'default';
  className?: string;
  label?: string;
};

function SproutsAIBadgeV2({ type, size, className, label = 'Sprouts AI' }: SproutsAIBadgeV2Props) {
  const [firstWord, secondWord] = label.split(' ');

  return (
    <span
      className={cx(
        className,
        'sprouts-ai-badge-v2',
        type === 'primary' && 'sprouts-ai-badge-primary',
        type === 'secondary' && 'sprouts-ai-badge-secondary',
        type === 'transparent' && 'sprouts-ai-badge-transparent',
        size === 'small' && 'sprouts-ai-badge-small',
      )}
    >
      <span
        className={cx(
          'icon-container',
          size === 'small' && 'icon-container-small',
          type === 'transparent' && 'icon-container-transparent',
          type === 'secondary' && 'icon-container-secondary',
          type === 'primary' && 'icon-container-primary',
        )}
      >
        <ThunderIcon width={8} height={12} viewBox="0 0 8 12" />
      </span>
      {size !== 'small' && (
        <p className="sprouts-ai-text">
          {size === 'default' && firstWord}{' '}
          {(size === 'medium' || size === 'default') && (secondWord || firstWord)}
        </p>
      )}
    </span>
  );
}

export default SproutsAIBadgeV2;
